import { Box } from '@mui/material';
import Markdown from 'markdown-to-jsx';
import { MarkdownComponentProps } from './markdown.interface';

const markdownSx = {
  maxWidth: '100%',
  minWidth: 0,
  overflowWrap: 'anywhere',
  '& p': { m: 0, mb: 1 },
  '& p:last-child': { mb: 0 },
  '& pre': {
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'auto',
    p: 1.5,
    borderRadius: 1,
    bgcolor: 'action.hover',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  '& pre code': {
    whiteSpace: 'inherit',
    wordBreak: 'inherit',
  },
  '& code': {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    fontSize: '0.875em',
  },
  '& ul, & ol': { pl: 3, my: 1 },
  '& a': { color: 'primary.main' },
  '& h1, & h2, & h3, & h4': { mt: 1.5, mb: 1 },
};

/** Keep single newlines as hard breaks; leave fenced code blocks untouched. */
function preserveNewlines(text: string) {
  return text
    .split(/(```[\s\S]*?```)/g)
    .map((part, index) =>
      index % 2 === 1 ? part : part.replace(/\n/g, '  \n'),
    )
    .join('');
}

export function MarkdownComponent({ text }: MarkdownComponentProps) {
  return (
    <Box sx={markdownSx}>
      <Markdown>{preserveNewlines(text)}</Markdown>
    </Box>
  );
}
